import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { environment } from '@app/env-service';

import { ProductCategory } from '../store/category.model';

@Injectable({
  providedIn: 'root',
})
// NOTE: This is deprecated. Don't add or reuse. Please check other CategoryService in V2.
export class CategoryService {
  url :string = environment.url;
  gettingRecords :boolean;

  readonly _productCategories = new BehaviorSubject<ProductCategory[]>([]);

  productCategories$ :ProductCategory[] = [];
  categories$ = this._productCategories.asObservable();

  constructor(private http :HttpClient) {
    this.getProductCategories();
  }

  getProductCategories() {
    this.gettingRecords = true;
    this.http
      .get(`${this.url}/product_categories`)
      .subscribe((data :ProductCategory[]) => {
        this.gettingRecords = false;
        this.productCategories$ = data;
        this._productCategories.next(data);
      });
  }

  getProductCategoryById(id :number) {
    return this.productCategories$.filter((el :any) => el.id == id);
  }
}
